import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Card, Container } from 'reactstrap'
import { uploadCSV } from 'store/Users/actions'
import { selectCSV } from 'store/Users/actions'
import File from '../File'
import ProgressiveButton from '../ProgressiveButton'

const ImportUser = (props) => {
  const dispatch = useDispatch()
  const users = useSelector((state) => state.users)

  return (
    <Container className='mt--6 pl-4' fluid>
      <Card
        className='col'
        style={{ height: '80vh', marginTop: '80px' }}
      >
        <div className='tab-content ml-5'>
          <form
            id='import-users-form'
            onSubmit={(e) => {
              e.preventDefault()
              dispatch(uploadCSV(e))
            }}
          >
            <div className='inner-settings-item'>
              <label>Select CSV File</label>
            </div>
            <div className='inner-settings-item pt-2'>
              <File onChange={(e) => dispatch(selectCSV(e))} name='csv' />
            </div>
            <div className='inner-settings-item pt-5'>
              <ProgressiveButton
                type={'submit'}
                form={'import-users-form'}
                placeholder={'Submit'}
                percent={users.uploadCSVPercent}
                status={users.uploadCSVStatus}
              />
              <Link
                className='btn bg-transparent shadow-none text-info border-0t'
                to={'/settings/users'}
              >
                Cancel
              </Link>
            </div>
          </form>
        </div>
      </Card>
    </Container >
  )
}
export default ImportUser
